import * as React from 'react';

import Imgix from 'js/components/Imgix';

type Props = {
  logoSrc: string;
  partnerId: number;
  partnerName: string;
};

const LOGO_HEIGHT = 20;
const LOGO_WIDTH = 20;

export const PartnerLogo = ({ logoSrc, partnerId, partnerName }: Props) => (
  <Imgix
    src={logoSrc}
    key={partnerId}
    alt={partnerName}
    maxHeight={LOGO_HEIGHT}
    maxWidth={LOGO_WIDTH}
    height={LOGO_HEIGHT}
    width={LOGO_WIDTH}
  />
);
